import { useState } from 'react';

export default function Hero() {
  const [showContactForm, setShowContactForm] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      await fetch('https://readdy.ai/api/form/d4hkhqser93evkarrqo0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString()
      });
      
      alert('Заявка отправлена! Мы свяжемся с вами в ближайшее время.');
      setShowContactForm(false);
      form.reset();
    } catch (error) {
      alert('Произошла ошибка. Попробуйте еще раз.');
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#1A2B4C] via-[#1A2B4C] to-[#1A2B4C]">
      {/* Background Image */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/08ffe48df3d7ca645f1847eca38bd1a5.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.3
        }}
      />
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#1A2B4C]/50 via-transparent to-[#1A2B4C]/80 z-0" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-20">
        <div className="text-left max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-['Playfair_Display'] font-bold text-white mb-6 leading-tight">
            Системный маркетинг и <span className="text-[#C5A880]">Искусственный Интеллект</span>: Ваш ключ к стабильному росту продаж
          </h1>
          
          <h2 className="text-xl md:text-2xl text-gray-300 mb-10 leading-relaxed max-w-3xl font-['Montserrat']">
            Превращаем хаос в систему. Объединяем экспертный опыт с точностью AI-алгоритмов, чтобы масштабировать ваш бизнес.
          </h2>

          <div className="flex flex-wrap gap-4">
            <button 
              onClick={() => setShowContactForm(true)}
              className="px-8 py-4 bg-[#C5A880] hover:bg-[#B39770] text-white font-semibold rounded-lg transition-all duration-300 shadow-lg shadow-[#C5A880]/50 hover:shadow-[#C5A880]/70 whitespace-nowrap cursor-pointer"
            >
              Получить стратегию роста
            </button>
            <button 
              onClick={() => {
                const element = document.getElementById('lead-form');
                element?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-8 py-4 bg-transparent border-2 border-white hover:bg-white hover:text-[#1A2B4C] text-white font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Обсудить проект
            </button>
          </div>
        </div>
      </div>

      {/* Contact Form Modal */}
      {showContactForm && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4" onClick={() => setShowContactForm(false)}>
          <div className="bg-white rounded-2xl p-8 max-w-lg w-full" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-start mb-6">
              <div>
                <h3 className="text-2xl font-bold text-[#1A2B4C] mb-2 font-['Playfair_Display']">Ваш маркетинг работает на 100% или сливает бюджет?</h3>
                <p className="text-gray-600 text-sm leading-relaxed font-['Montserrat']">
                  Не гадайте. Получите честный взгляд со стороны. Запишитесь на <strong className="text-[#C5A880]">бесплатную 20-минутную экспресс-диагностику</strong> вашего проекта.
                </p>
              </div>
              <button onClick={() => setShowContactForm(false)} className="text-gray-500 hover:text-gray-700 cursor-pointer flex-shrink-0 ml-4">
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <div className="bg-gradient-to-br from-[#F8F9FA] to-[#F8F9FA] rounded-xl p-5 mb-6">
              <h4 className="font-bold text-[#1A2B4C] mb-3 text-sm font-['Montserrat']">Что вы узнаете:</h4>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-[#C5A880] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-search-line text-white text-xs"></i>
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed font-['Montserrat']">
                    Где вы теряете клиентов прямо сейчас (поиск «дыр» в воронке)
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-[#C5A880] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-line-chart-line text-white text-xs"></i>
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed font-['Montserrat']">
                    3 неочевидные точки роста для масштабирования выручки
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-[#C5A880] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-robot-line text-white text-xs"></i>
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed font-['Montserrat']">
                    Как ИИ может снизить ваши расходы на рекламу
                  </p>
                </div>
              </div>
            </div>

            <form className="space-y-4 font-['Montserrat']" data-readdy-form id="hero-contact-form" onSubmit={handleSubmit}>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  Имя <span className="text-red-500">*</span>
                </label>
                <input 
                  type="text" 
                  name="name" 
                  placeholder="Ваше имя" 
                  required 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C5A880] text-sm" 
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  Телефон <span className="text-red-500">*</span>
                </label>
                <input 
                  type="tel" 
                  name="phone" 
                  placeholder="+7 (999) 123-45-67" 
                  required 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C5A880] text-sm" 
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  Интересующая услуга <span className="text-red-500">*</span>
                </label>
                <select 
                  name="service" 
                  required 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C5A880] text-sm bg-white cursor-pointer"
                >
                  <option value="">Выберите услугу</option>
                  <option value="Цифровой Маркетинг 360°">Цифровой Маркетинг 360°</option>
                  <option value="Комплексная стратегия маркетинга">Комплексная стратегия маркетинга</option>
                  <option value="Консалтинг по маркетингу">Консалтинг по маркетингу</option>
                  <option value="Стратегическое управление и Партнерство для производителей на маркетплейсах">Стратегическое управление и Партнерство для производителей на маркетплейсах</option>
                  <option value="Консалтинг маркетплейс">Консалтинг маркетплейс</option>
                  <option value="Создание продающих сайтов">Создание продающих сайтов</option>
                  <option value="Контекстная реклама">Контекстная реклама</option>
                  <option value="Таргетированная реклама">Таргетированная реклама</option>
                  <option value="SMM и Контент">SMM и Контент</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1.5">
                  Ссылка на сайт <span className="text-gray-400 text-xs">(необязательно)</span>
                </label>
                <input 
                  type="url" 
                  name="website" 
                  placeholder="https://example.com" 
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C5A880] text-sm" 
                />
              </div>
              <button type="submit" className="w-full px-6 py-3 bg-gradient-to-r from-[#C5A880] to-[#B39770] hover:from-[#B39770] hover:to-[#A28660] text-white font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
                Получить стратегию роста
              </button>
              <p className="text-xs text-gray-500 text-center">
                Нажимая на кнопку, я даю согласие на обработку персональных данных и соглашаюсь с политикой конфиденциальности
              </p>
            </form>
          </div>
        </div>
      )}

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
